import classNames from "classnames";
import styles from "./Hamburger.module.css";
import { useWebTranslation } from "translations";

export const Hamburger = ({
  isOpen,
  onClick,
}: {
  isOpen: boolean;
  onClick: () => void;
}) => {
  const { t } = useWebTranslation();

  return (
    <button
      onClick={onClick}
      className={styles.container}
      aria-label={t("a11y.signup.toggle_menu ")}
    >
      <div
        style={{
          transform: isOpen
            ? "translate(2px) rotate(45deg)"
            : "translate(0) rotate(0)",
        }}
        className={classNames(styles.bar, styles.barTop)}
      ></div>
      <div
        style={{
          transform: isOpen
            ? "translate(2px) rotate(-45deg)"
            : "translate(0) rotate(0)",
        }}
        className={classNames(styles.bar, styles.barBottom)}
      />
    </button>
  );
};
